import Vue from 'vue';
import ediOrderTransformer from '../../transformers/ediOrder';

const success = (data, resolve) => {
  const result = {
    errors: data.errors,
    data: ediOrderTransformer.fetchCollection(data.data),
  };
  resolve(result);
};

export default (orderIds, ediOrder) => (
  new Promise((resolve, reject) => {
    const url = `edi_orders/confirm?order_ids=${orderIds.join(',')}`;
    Vue.$http
      .post(url, ediOrder)
      .then((response) => {
        success(response.data, resolve);
      })
      .catch((error) => {
        reject(error.response);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/ediOrder/bulkConfirm.js